import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { environment } from "src/environments/environment";
import { IIntesaFormFieldsResponse } from "./isv.constants";

@Injectable({
    providedIn: 'root'
})
export class IsvService {

    constructor(
        private _http: HttpClient
    ) { }

    retrieveIsvFormInfo(operationId: string, policyId: string, contractNumber: string, operationStatus: string, idAnagrafico?: string): Observable<IIntesaFormFieldsResponse> {
        if (this.isLocalEnv) {
            return of(null);
        }
        const url = environment.apiBaseUrl + environment.apiPaths.isvFormInfo;
        let params = new HttpParams()
            .set('operationCode', operationId)
            .set('policyNumber', policyId)
            .set('contractNumber', contractNumber)
            .set('operationStatus', operationStatus);
        if (idAnagrafico)
            params = params.set('idAnagrafico', idAnagrafico);

        return this._http.get<IIntesaFormFieldsResponse>(url, {
            params: params
        });
    }

    checkTariffazione(body: any): Observable<any> {
        const url = environment.apiBaseUrl + environment.apiPaths.tariffazione;
        if (this.isLocalEnv) {
          return this._http.get(url);
        }
        return this._http.post<any>(url, body);
    }

    perfezionareTariffazione(body: any): Observable<any> {
        const url = environment.apiBaseUrl + environment.apiPaths.perfezionare;
        if (this.isLocalEnv) {
          return this._http.get(url);
        }
        return this._http.post<any>(url, body);
    }

    confirmOperation(body: any, operationId: string): Observable<any> {
        const url = environment.apiBaseUrl + environment.apiPaths.intesa[operationId];
        if (this.isLocalEnv) {
          return this._http.get(url);
        }
        return this._http.post<any>(url, body);
    }

    searchSubjectByTaxCode(taxOrVatCode: string, contractNumber: string): Observable<any> {
        const url = environment.apiBaseUrl + environment.apiPaths.isvSearchSubject;

        let params = new HttpParams()
          .set('contractNumber', contractNumber);

        if (this.isPartitaIVA(taxOrVatCode)) {
          params = params.set('vatCode', taxOrVatCode);
        } else {
          params = params.set('fiscalCode', taxOrVatCode);
        }
        return this._http.get<any>(url, { params: params });
    }

    get isLocalEnv(): boolean {
        return environment.name === 'LOCAL' || environment.name === 'LOCAL_BE';
    }

    isPartitaIVA(value: string): boolean {
        return /^[0-9]{11}$/.test(value);
    }
}
